import src from "IMAGE";
export default { src, width: 1920, height: 317, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAHElEQVR42mPg4GCX5OTgkOQAYm5ubjDNyYngAwAZdAGdfHF7JgAAAABJRU5ErkJggg=="};
